const DEFAULT_LOCAL_API_BASE = "http://127.0.0.1:8000/api";
const DEFAULT_PUBLIC_API_BASE = "https://ctfglobal.in/api/backend/public/api";

function uniqueValues(values) {
  return [...new Set(values.filter(Boolean))];
}

function isLocalApiBase(base) {
  if (!base) return false;
  try {
    const hostname = new URL(base).hostname;
    return hostname === "localhost" || hostname === "127.0.0.1";
  } catch {
    return false;
  }
}

export function getPublicApiBaseCandidates() {
  const envBase = process.env.REACT_APP_API_URL;

  if (typeof window === "undefined") {
    return uniqueValues([envBase, DEFAULT_PUBLIC_API_BASE, DEFAULT_LOCAL_API_BASE]);
  }

  const hostname = window.location.hostname;
  const isLocalHost = hostname === "localhost" || hostname === "127.0.0.1";
  const canonicalOrigin =
    hostname === "www.ctfglobal.in"
      ? "https://ctfglobal.in"
      : window.location.origin;

  const productionBases = [
    `${canonicalOrigin}/api/backend/public/api`,
    `${canonicalOrigin}/backend/public/api`,
    `${canonicalOrigin}/api`,
  ];

  if (isLocalHost) {
    return uniqueValues([envBase, DEFAULT_LOCAL_API_BASE, ...productionBases]);
  }

  return uniqueValues([
    envBase && !isLocalApiBase(envBase) ? envBase : null,
    ...productionBases,
    DEFAULT_PUBLIC_API_BASE,
  ]);
}

export async function publicApiJson(endpoint, options = {}) {
  const bases = getPublicApiBaseCandidates();
  let lastError;

  for (let i = 0; i < bases.length; i += 1) {
    const base = bases[i];

    try {
      const res = await fetch(`${base}${endpoint}`, options);
      const text = await res.text();
      let data;

      try {
        data = text ? JSON.parse(text) : {};
      } catch {
        const parseError = new Error(
          res.ok ? "Invalid JSON from server" : `Request failed (${res.status})`
        );
        const looksLikeHtml = /^\s*</.test(text);
        if (i < bases.length - 1 && (res.status === 404 || looksLikeHtml)) {
          lastError = parseError;
          continue;
        }
        throw parseError;
      }

      if (!res.ok) {
        if (i < bases.length - 1 && res.status === 404) {
          lastError = new Error(`Request failed (${res.status})`);
          continue;
        }

        const msg =
          data?.message || data?.error || `Request failed (${res.status})`;
        const err = new Error(msg);
        err.status = res.status;
        err.data = data;
        throw err;
      }

      return data;
    } catch (error) {
      if (i === bases.length - 1) {
        throw error;
      }
      lastError = error;
    }
  }

  throw lastError || new Error("Backend not reachable");
}
